<template>
  <div class="disclaimer">
    Ветровой расчет выполнен по методике СТО 72746455-4.1.4-2018 «КРЫШИ. КРОВЕЛЬНЫЕ СИСТЕМЫ С
    ВОДОИЗОЛЯЦИОННЫМ КОВРОМ ИЗ ПОЛИМЕРНЫХ И БИТУМОСОДЕРЖАЩИХ РУЛОННЫХ МАТЕРИАЛОВ». В связи с
    программным ограничением построения сложных схем кровель, все схемы приводятся к простой
    геометрии. Расчет носит ознакомительный характер. Для объекта расчёта необходимо проверить
    ветровой район согласно приложению Е действующего СП 20.13330 «НАГРУЗКИ И ВОЗДЕЙСТВИЯ».
    Для получения гарантии необходимо согласовать расчет с Проектно-расчетным центром
    ТехноНИКОЛЬ (<a href="mailto:prc@tn.ru">prc@tn.ru</a>).
  </div>
</template>

<script>
export default {
  name: 'Disclaimer',
};
</script>

<style lang="sass" scoped>
.disclaimer
  font-style: normal
  font-weight: normal
  font-size: rem(12)
  line-height: 180%
  color: $black
  text-align: left
  +media((margin-top: (320: rem(40), 768: rem(51))))
  +media((padding: (320: 0 rem(24), 992: 0)))
  a
    color: $red
</style>
